<template>
  <div>
    <v-dialog
      :value="value"
      persistent
      max-width="50rem">
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-md>
              <v-layout>
                <v-flex>
                  <v-autocomplete
                    v-model="editedCert.insuranceId"
                    :items="insurances"
                    :rules="[v => !!v || 'Insurance is required']"
                    disabled
                    item-text="name"
                    item-value="id"
                    label="Insurance"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    v-model="editedCert.link"
                    :rules="[v => !!v || 'Link is required']"
                    label="Link to document"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    :value="formatLLL(editedCert.dateIssue)"
                    label="Issue date"
                    @click="dateIssueDialog = true"/>
                </v-flex>
                <v-flex>
                  <v-text-field
                    :value="formatLLL(editedCert.dateExpiry)"
                    label="Expiry date"
                    @click="dateExpiryDialog = true"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-textarea
                    v-model="editedCert.info"
                    rows="1"
                    auto-grow
                    label="More"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="$emit('input', false)">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="save">
            <v-progress-circular
              v-if="posting"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DATE ISSUE DIALOG -->
    <picker-dialog
      v-model="dateIssueDialog"
      :date-iso.sync="editedCert.dateIssue"/>
    <!-- DATE EXPIRY DIALOG -->
    <picker-dialog
      v-model="dateExpiryDialog"
      :date-iso.sync="editedCert.dateExpiry"/>
  </div>
</template>

<script>
import moment from "moment";
import PickerDialog from "../../SharedComponents/PickerDialog";

export default {
  name: "edit-dialog",
  components: { PickerDialog },
  props: {
    certificate: {
      required: true,
      type: Object
    },
    insurances: {
      required: true,
      type: Array
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dateExpiryDialog: false,
      dateIssueDialog: false,
      editedCert: {
        dateExpiry: null,
        dateIssue: null,
        info: "",
        link: "",
        insuranceId: null
      },
      posting: false,
      valid: false
    };
  },
  watch: {
    value (newVal) {
      if (newVal === true) {
        this.editedCert = Object.assign({}, this.certificate);
      }
    }
  },
  methods: {
    formatLLL (iso) {
      return iso ? moment(iso).format("LLL") : " … ";
    },
    save () {
      this.posting = true;
      this.$http.
        put(`/api/franchise_insurances_certs/${this.editedCert.id}`, {
          dateExpiry: this.editedCert.dateExpiry
            ? moment(this.editedCert.dateExpiry).format("YYYY-MM-DDTHH:mm:ss")
            : null,
          dateIssue: this.editedCert.dateIssue
            ? moment(this.editedCert.dateIssue).format("YYYY-MM-DDTHH:mm:ss")
            : null,
          info: this.editedCert.info,
          link: this.editedCert.link,
          insuranceId: this.editedCert.insuranceId
        }).
        then(() => {
          this.posting = false;
          this.$emit("input", false);
          this.$emit("refresh");
        }).
        catch(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Franchise/InsurancesTable/EditCertDialog.vue